import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Input, InputGroup, InputGroupText } from "reactstrap"

const PRESET_DURATIONS = [30, 60, 90, 120]

const AvailabilityDurationInput = ({ error, id, invalid, onChange, value }) => {
  const isPreset = PRESET_DURATIONS.includes(Number(value))
  const [isCustom, setIsCustom] = useState(!isPreset)

  useEffect(() => {
    if (!PRESET_DURATIONS.includes(Number(value))) setIsCustom(true)
  }, [value])

  const selectValue = isCustom ? "custom" : String(value)

  return (
    <div className="duration-input">
      <Input
        id={id}
        type="select"
        value={selectValue}
        invalid={invalid && !isCustom}
        onChange={event => {
          if (event.target.value === "custom") {
            setIsCustom(true)
            return
          }
          setIsCustom(false)
          onChange(event.target.value)
        }}
      >
        {PRESET_DURATIONS.map(duration => (
          <option value={duration} key={duration}>
            {duration} minutes
          </option>
        ))}
        <option value="custom">Custom</option>
      </Input>

      {isCustom && (
        <InputGroup className="mt-2 has-validation">
          <Input
            aria-label="Custom appointment duration in minutes"
            type="number"
            min="1"
            max="1440"
            step="1"
            value={value}
            invalid={invalid}
            onChange={event => onChange(event.target.value)}
          />
          <InputGroupText>minutes</InputGroupText>
        </InputGroup>
      )}

      {invalid && error && (
        <div className="invalid-feedback d-block">{error}</div>
      )}
    </div>
  )
}

AvailabilityDurationInput.propTypes = {
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default AvailabilityDurationInput
